@switch (errorCode$ | async) {
  @case (b2i) {
    <dcp-add-company-details-error></dcp-add-company-details-error>
  }
  @case (cpea) {
    <dcp-add-to-existing-contract-error></dcp-add-to-existing-contract-error>
  }
  @case (payg) {
    <dcp-new-contract-error></dcp-new-contract-error>
  }
  @case (unavailable) {
    <dcp-checkout-unavailable></dcp-checkout-unavailable>
  }
  @case (restructure) {
    <dcp-configure-restructure-error></dcp-configure-restructure-error>
  }
  @default {
    <dcp-default-configurator-error></dcp-default-configurator-error>
  }
}
